import {
  IValueFormatter,
  currencyFormatter,
} from "../../../records/csv/formatters";

export const meterReadingFormatter: (config?: {
  meterReadingField?: string;
  unableToGetReadingField?: string;
  conditionNotMetField?: string;
}) => IValueFormatter = (config) => {
  return (params: { cellValue: any; row: any }) => {
    const meterReadingField = config?.meterReadingField || "MeterReading";
    const { row } = params;
    const unableToGetReading: boolean = config?.unableToGetReadingField
      ? row[config.unableToGetReadingField]
      : false;
    const conditionNotMet: boolean = config?.conditionNotMetField
      ? row[config.conditionNotMetField]
      : false;

    if (unableToGetReading) {
      return "Unable to get reading";
    }

    if (conditionNotMet) {
      return "Condition not met";
    }

    const readingValue: number | undefined = row[meterReadingField];

    if (!readingValue) {
      return undefined;
    }

    return currencyFormatter(params);
  };
};
